import { PFAFreeProductBoostInput } from '@frontend/applications/AffiliatesApp/types/globalTypes';
import { Button } from '@frontend/shadcn/components/ui/button';
import { Card, CardContent } from '@frontend/shadcn/components/ui/card';
import { ExternalLink, X } from 'lucide-react';
import React from 'react';

export default function GiftProductsList(props: { selectedGiftVariants: PFAFreeProductBoostInput[], handleRemoveGiftVariant: (variantId: string) => void }): JSX.Element {
  const { selectedGiftVariants, handleRemoveGiftVariant } = props;

  return (
    <div className="flex flex-col items-start justify-end gap-2 relative">
      <div className="flex items-start gap-4 relative self-stretch w-full">
        <div className="flex flex-col items-start justify-center gap-2 relative flex-1 grow">
          <div className="relative self-stretch mt-[-1.00px] font-medium-75-labels font-[number:var(--medium-75-labels-font-weight)] text-grey-6 text-[length:var(--medium-75-labels-font-size)] tracking-[var(--medium-75-labels-letter-spacing)] leading-[var(--medium-75-labels-line-height)] [font-style:var(--medium-75-labels-font-style)]">
            Select Product
          </div>
          {selectedGiftVariants.map((variant) => (
            <Card
              key={variant.variantId}
              className="flex flex-col items-start gap-2 p-2 relative self-stretch w-full bg-grey-0 rounded-xl overflow-hidden border border-solid border-grey-2"
            >
              <CardContent className="flex items-center gap-3 relative self-stretch w-full p-0">
                <div
                  className="relative w-10 h-10 rounded-xl bg-cover bg-[50%_50%]"
                  style={{ backgroundImage: `url(${variant.productImageUrl})` }}
                />
                <div className="flex items-center gap-3 relative flex-1 grow">
                  <div className="flex flex-col items-start justify-center relative flex-1 grow">
                    <div className="relative self-stretch mt-[-1.00px] font-medium-100 font-[number:var(--medium-100-font-weight)] text-grey-6 text-[length:var(--medium-100-font-size)] tracking-[var(--medium-100-letter-spacing)] leading-[var(--medium-100-line-height)] [font-style:var(--medium-100-font-style)]">
                      {variant.quantity} x {variant.productTitle}
                    </div>
                    <div className="relative self-stretch font-regular-75-caption font-[number:var(--regular-75-caption-font-weight)] text-grey-5 text-[length:var(--regular-75-caption-font-size)] tracking-[var(--regular-75-caption-letter-spacing)] leading-[var(--regular-75-caption-line-height)] [font-style:var(--regular-75-caption-font-style)]">
                      {variant.variantTitle}
                    </div>
                  </div>
                  <div className="inline-flex items-center justify-end relative">
                    {variant.productUrl && (
                      <Button variant="ghost" size="icon" className="w-8 h-8 p-2 rounded-lg" asChild>
                        <a href={variant.productUrl} target="_blank" rel="noopener noreferrer">
                          <ExternalLink className="w-3 h-3 text-grey-6" />
                        </a>
                      </Button>
                    )}
                    <Button variant="ghost" size="icon" className="w-8 h-8 p-2 rounded-lg" onClick={() => handleRemoveGiftVariant(variant.variantId)}>
                      <X className="w-3 h-3 text-grey-9" />
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
